<template>
  <div>
    <template v-if="!awardResult">
      <template v-if="currentPageIsShare">
        <blessing-bag v-if="showBlessingBag" @click="onExtraAward" :blessing-bag="blessingBag" />
        <red-reward-button v-else @click="onExtraAward" />
      </template>
      <template v-else>
        <div class="extra-bg-box" @click="onExtraAward"></div>
      </template>
    </template>
    <template v-else>
      <template v-if="awardResult.hasReward && awardYuanAmount">
        <split-box style="background-color: #ffd7d7">
          <template v-slot:top-content>
            <div class="text-center">
              <p class="mb-2">
                <span class="text-theme-black-850 text-small leading-22">
                  <span v-if="enableNetManualAudit">恭喜您抽中红包，红包将在问卷发布者审核通过后发放</span>
                  <span v-else>恭喜您抽中红包</span>
                </span>
              </p>
              <template v-if="awardYuanAmount">
                <span class="amount-of-money">{{ awardYuanAmount ? awardYuanAmount.toFixed(2) : '' }}</span>
                <span>元</span>
              </template>
            </div>
          </template>
        </split-box>
      </template>
      <template v-else>
        <div class="bg-white p-4 shadow-theme rounded-small mt-4">
          <div class="text-small text-theme-black-450 text-center leading-18">
            <div>
              <img src="~@/assets/img/answer/regret.png" alt="" width="132" />
            </div>
            <template v-if="!allowAwardWithoutFollow">
              <p>真遗憾，红包与您擦肩而过</p>
            </template>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { bindExtraAward, busGetters } from 'dygc'
import SplitBox from '@/components/SplitBox'
import { createPopup } from '@/assets/js/factory'
import WeixinShareTip from '@/components/overlay/WeixinShareTip'
import RedRewardButton from '@/components/base/RedRewardButton'
import BlessingBag from 'components/blessing-bag/BlessingBag'

export default {
  name: 'ExtraAward',
  components: { SplitBox, RedRewardButton, BlessingBag },
  data() {
    return {
      awardResult: null
    }
  },
  computed: {
    awardYuanAmount() {
      return this.awardResult?.awardYuanAmount
    },
    showBlessingBag() {
      return this.redEnvelopesType === 1
    },
    redEnvelopesType() {
      return this.$bus.survey.otherSetting.redEnvelopesType
    },
    blessingBag() {
      return this.$bus.survey.otherSetting.blessingBag || { list: [], num: 0 }
    },
    ...busGetters(['enableNetManualAudit', 'allowAwardWithoutFollow', 'currentPageIsShare'])
  },
  methods: {
    bindExtraAward() {
      this.$bus.openLoading()
      bindExtraAward(this.$bus.answerId)
        .then(res => {
          this.awardResult = res.data
          this.$bus.closeLoading()
        })
        .catch(() => {
          this.$bus.closeLoading()
        })
    },
    onExtraAward() {
      if (!this.$bus.currentPageIsShare) {
        createPopup(WeixinShareTip)
        return
      }
      this.bindExtraAward()
    }
  }
}
</script>

<style scoped>
.extra-bg-box {
  background-image: url(~@/assets/img/answer/extra-award.png);
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 95px;
}
</style>
